export default __webpack_public_path__ + "static/media/90.a63f3844.svg";